<template>
  <div class="container">
    <!--<el-date-picker-->
    <!--v-model="filters.daterange"-->
    <!--type="d aterange"-->
    <!--placeholder="选择日期">-->
    <!--</el-date-picker>-->
    <!--    <el-checkbox v-model="!filters.onlyUnchecked"></el-checkbox>-->
    <el-row :gutter="10" v-if="userGroup > 499" class="btn-wrapper">
      <el-button
        type="primary"
        size="mini"
        :disabled="selectedLabelTaskId.length === 0"
        >开始训练</el-button
      >
      <el-button
        type="primary"
        :disabled="selectedLabelTaskId.length === 0"
        size="mini"
        @click="viewSummary"
        >查看统计</el-button>
      <zipTaskBtns :selectedLabelTaskId="selectedLabelTaskId"></zipTaskBtns>
      &nbsp;
      <el-checkbox v-model="filters.dateFilter">日期筛选</el-checkbox>
      <el-date-picker
        :clearable="false"
        v-if="filters.dateFilter"
        v-model="filters.daterange"
        type="daterange"
        size="mini"
        placeholder="选择日期">
      </el-date-picker>
    </el-row>

    <el-row :gutter="10" class="btn-wrapper">
      <el-button type="text" size="mini" @click="allSelect">全选</el-button>
      <el-button
        type="text"
        class="danger-text"
        @click="cancelAll"
        :disabled="selectedLabelTaskId.length === 0"
        size="mini"
        >取消
      </el-button>
      <el-input
        v-model="filters.searchText"
        class="search-box"
        size="mini"
        placeholder="快速搜索"
      ></el-input>
      <el-radio v-model="filters.onlyUnchecked" label="2">只看已分类</el-radio>
      <el-radio v-model="filters.onlyUnchecked" label="3">只看未分类</el-radio>
      <el-radio v-model="filters.onlyUnchecked" label="1">只看未纠错</el-radio>
      <el-radio v-model="filters.onlyUnchecked" label="0">只看已纠错</el-radio>
      <el-radio v-model="filters.onlyUnchecked" label="-1">全部</el-radio>
      <el-badge class="mark" :value="selectedLabelTaskId.length">
        <el-tag type="primary" size="mini">已选 </el-tag>
      </el-badge>
      &nbsp;
      <el-badge class="mark" :value="filterdLabelTaskList.length">
        <el-tag type="success" size="mini">总计</el-tag>
      </el-badge>
      &nbsp;
      <el-badge class="mark" :value="unCheckedTaskList.length">
        <el-tag type="danger" size="mini">未纠错</el-tag>
      </el-badge>
      &nbsp;
      <el-badge class="mark" :value="count">
        <el-tag type="success" size="mini">图片总计</el-tag>
      </el-badge>
    </el-row>
    <vvTable
      :height="800"
      :data="filterdLabelTaskList"
      :config="tableConfig"
      :itemHeight="40"
    >
      <template slot-scope="scope" slot="selection_slot">
        <el-button
          type="text"
          size="mini"
          v-if="selectedLabelTaskId.indexOf(scope.row.label_task_id) === -1"
          @click="select(scope.row)"
          >选择
        </el-button>
        <el-button
          type="text"
          size="mini"
          v-else
          class="danger-text"
          @click="cancelSelect(scope.row)"
          >取消
        </el-button>
      </template>
      <template slot-scope="scope" slot="canteen_slot">
        {{ findCanteen(scope.row) }}
      </template>

      <template slot-scope="scope" slot="machine_slot">
        {{ scope.row.machine_id || "未关联机器" }}
      </template>
      <template slot-scope="scope" slot="source_slot">
        <el-tag type="primary" v-if="scope.row.source === '1'" size="mini"
          >采集</el-tag
        >
        <el-tag type="warning" v-if="scope.row.source === '2'" size="mini"
          >回测</el-tag
        >
        <el-tag type="success" v-if="scope.row.source === '3'" size="mini"
          >上传</el-tag
        >
        <i calss="el-icon el-icon-ali-fire"></i>
      </template>

      <template slot-scope="scope" slot="label_date_slot">
        {{ scope.row.label_task_day_ts | tsToDate }}
      </template>
      <template slot-scope="scope" slot="create_ts_slot">
        {{ scope.row.create_ts | tsToDate }}
      </template>
      <template slot-scope="scope" slot="category_slot">
        <el-tag v-if="scope.row.is_category === 1" type="success" size="mini">已分类
        </el-tag>
        <el-tag v-else type="danger" size="mini">未分类
        </el-tag>
      </template>
      <template slot-scope="scope" slot="status_slot">
        <el-tag v-if="scope.row.is_mark" type="success" size="mini">已标注
        </el-tag>
        <el-tag v-else type="danger" size="mini">未标注</el-tag>
        <el-tag v-if="scope.row.is_check" type="success" size="mini"
          >已纠错
        </el-tag>
        <el-tag v-else type="danger" size="mini">未纠错</el-tag>
        <el-tag type="primary" size="mini" v-if="scope.row.is_checking === 1"
          ><i class="el-icon-loading"></i>纠错中
        </el-tag>
      </template>
      <template slot-scope="scope" slot="count_slot"
        >{{ scope.row.count || 0 }}
      </template>
      <template slot-scope="scope" slot="user_slot">
        {{ scope.row.who_check ? scope.row.who_check : "-" }}
      </template>
      <template slot-scope="scope" slot="event_slot">
        <el-button
          :disabled="scope.row.is_mark === 1 || scope.row.source !== '3'"
          type="text"
          size="mini"
          @click="premrk(scope.row)"
          >预标注
        </el-button>
        <el-button
          type="text"
          v-if="scope.row.is_mark === 1 || scope.row.source !== '3'"
          @click="viewDetail(scope.row)"
          size="mini"
          :disabled="
            scope.row.who_check !== '' &&
            scope.row.who_check !== username &&
            scope.row.is_checking === 1"
          >纠错
        </el-button>
        <el-button
          type="text"
          class="danger-text"
          size="mini"
          v-if="scope.row.is_checking === 1"
          :disabled="scope.row.who_check !== username"
          @click="cancelCheck(scope.row)"
          >取消纠错
        </el-button>
      </template>
    </vvTable>
    <el-dialog
      :append-to-body="true"
      title="错误统计"
      :visible.sync="summaryDialog"
      width="600"
    >
      <el-badge class="mark" :value="regionReasonSummary.new_region_count">
        <el-button type="primary" size="mini" @click="downloadImage('more')"
          >下载多框</el-button
        >
      </el-badge>
      &nbsp;
      <el-badge class="mark" :value="regionReasonSummary.less_region_count">
        <el-button type="primary" size="mini" @click="downloadImage('less')"
          >下载漏框</el-button
        >
      </el-badge>
      <el-button type="primary" size="mini" @click="exportExcel">导出excel</el-button>
      <el-table :height="400" :data="selectedLabelTask" style="width: 100%" id="out-table">
        <el-table-column header-align="center" align="center" label="餐厅" width="200">
          <template slot-scope="scope">
            {{ findCanteen(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="批次日期" width="150">
          <template slot-scope="scope">
            {{ scope.row.label_task_day_ts | tsToDate }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="机器">
          <template slot-scope="scope">
            {{ scope.row.machine_id || "未关联机器" }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="总计">
          <template slot-scope="scope">
            {{ scope.row.count }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="多框">
          <template slot-scope="scope">
            {{ scope.row.new_region_num }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="漏框">
          <template slot-scope="scope">
            {{ scope.row.less_region_num }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import {apiGetReasonCount} from '@/api';
import vvTable from 'vue-virtual-table';
import moment from 'moment';
import pinyinMatch from 'pinyin-match';
import downloadImagesFormZip from '@/lib/downloadImagesFormZip';
import util from '@/lib/util';
import zipTaskBtns from './zipTaskBtns';

export default {
  name: "labelTaskAdmin",
  props: {
    labelTaskList: {
      type: Array
    }
  },
  components: {
    vvTable,
    zipTaskBtns
  },
  data() {
    return {
      dateRange: [new Date().getTime(), new Date().getTime()],
      regionReasonSummary: {},
      summaryDialog: false,
      selectedLabelTaskId: [],
      filters: {
        onlyUnchecked: '-1',
        daterange: [
          new Date(new Date().getTime() - 3 * 24 * 3600 * 1000),
          new Date()
        ],
        dateFilter: false
      },
      zipTaskShow: false,
      allZipTask: []
    };
  },
  mounted() {

  },
  methods: {
    ...mapMutations(["setSubTitle", "removeLoading", "emitLoading"]),
    ...mapActions([]),
    exportExcel () {
      let wb = XLSX.utils.table_to_book(document.querySelector('#out-table'));
      let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'eventSummary.xlsx');
      } catch (e) {
      }
    },
    async downloadImage(flag) {
      this.emitLoading();
      let list = [];
      let filename = '';
      if (flag === "less") {
        list = this.regionReasonSummary.less_region_img_url_list;
        filename = '漏框images';
      } else {
        list = this.regionReasonSummary.new_region_img_url_list;
        filename = '多框images';
      }
      try {
        const res = await downloadImagesFormZip(list, filename);
        if (res === true) {
          this.removeLoading();
          this.$message.success('生成zip成功');
        } else {
          console.log(res);
          this.removeLoading();
          this.$message.error('生成zip失败');
        }
      } catch (e) {
        console.log(e);
        this.removeLoading();
        this.$message.error('生成zip失败');
      }
    },
    cancelCheck(row) {
      this.$emit("cancelCheck", row);
    },
    async viewSummary() {
      // this.$message.error('开发中... ');
      this.summaryDialog = true;
      try {
        this.emitLoading();
        const res = await apiGetReasonCount(this.selectedLabelTaskId);
        this.regionReasonSummary = res;

        this.removeLoading();
      } catch (e) {
        console.log(e);
        this.removeLoading();
        this.$message.error("查询失败");
      }
    },
    cancelAll() {
      this.selectedLabelTaskId = [];
    },
    select(row) {
      let { label_task_id } = row;
      if (this.selectedLabelTaskId.indexOf(label_task_id) === -1) {
        this.selectedLabelTaskId.push(label_task_id);
      }
    },
    // selectOthers() {
    //   // let ids =
    //   this.selectedLabelTaskId = this.
    // },
    allSelect() {
      // this.selectedLabelTaskId.(this.label_task_ids);
      this.selectedLabelTaskId = this.$_.concat(
        this.selectedLabelTaskId,
        this.label_task_ids
      );
    },
    cancelSelect(row) {
      const { label_task_id } = row;
      console.log(label_task_id);
      const idx = this.$_.findIndex(
        this.selectedLabelTaskId,
        a => a === label_task_id
      );
      console.log(idx);
      this.selectedLabelTaskId.splice(idx, 1);
    },
    viewDetail(row) {
      this.$emit("viewDetail", row);
    },
    premrk(row) {
      this.$emit("preMark", row);
    },
    findCanteen(row) {
      const canteen_id = Number(row.canteen_id);
      let res = this.$_.find(
        this.allCanteenList,
        a => a.canteen_id === canteen_id
      );
      const noCanteen = "无记录";
      if (res) {
        return res.eatery_name + ", " + res.canteen_name;
      } else {
        return "无记录";
      }
    }
  },
  computed: {
    ...mapGetters(["allCanteenList", "userinfo"]),
    count() {
      let count = 0;
      this.filterdLabelTaskList.forEach(a => {
        count += Number(a.count);
      });
      return count;
    },
    username() {
      return this.userinfo().username;
    },
    userGroup() {
      return this.userinfo().userGroup;
    },
    unCheckedTaskList() {
      return this.filterdLabelTaskList.filter(a => a.is_check === 0);
    },
    filterTs() {
      return [
        util.dateToUnixtimestamp(this.filters.daterange[0], 0),
        util.dateToUnixtimestamp(this.filters.daterange[1], 1)
      ];
    },
    filterdLabelTaskList() {
      let list = this.$_.cloneDeep(this.labelTaskList);

      list.forEach(a => {
        a.label_task_day_ts = a.label_task_day_ts || a.create_ts;
      });
      if (this.filters.onlyUnchecked === "1") {
        list = list.filter(a => a.is_check === 0);
      } else if (this.filters.onlyUnchecked === "0") {
        list = list.filter(a => a.is_check === 1);
      } else if (this.filters.onlyUnchecked === '2') {
        list = list.filter(a => a.is_category === 1);
      } else if (this.filters.onlyUnchecked === '3') {
        list = list.filter(a => a.is_category === 0);
      }
      if (this.filters.dateFilter) {
        list = list.filter(a => {
          return (a.label_task_day_ts > this.filterTs[0] || a.label_task_day_ts === this.filterTs[0]) &&
            (a.label_task_day_ts < this.filterTs[1]);
        });
      }
      console.log(list);
      const searchText = this.filters.searchText;
      if (searchText) {
        list = list.filter(a => {
          const canteen = this.findCanteen(a);
          let res = pinyinMatch.match(canteen, searchText);
          // console.log(res);
          return res.length > 0;
        });
      }
      list = this.$_.orderBy(
        list,
        ["label_task_day_ts", "is_check"],
        ["desc", "desc"]
      );
      return list;
    },
    // selectedLabelTaskId () {
    //   return this.selectedLabelTaskId();
    // },
    label_task_ids() {
      return this.filterdLabelTaskList.map(a => a.label_task_id);
    },
    selectedLabelTask() {
      let list = this.$_.cloneDeep(this.labelTaskList);
      let labels = this.$_.intersectionWith(
        list,
        this.selectedLabelTaskId,
        (leftVal, rightVal) => leftVal.label_task_id === rightVal
      );
      let { regions_info_dic } = this.regionReasonSummary;
      labels.forEach(a => {
        if (
          regions_info_dic &&
          regions_info_dic.hasOwnProperty(a.label_task_id)
        ) {
          this.$set(
            a,
            "less_region_num",
            regions_info_dic[a.label_task_id].less_region_num
          );
          this.$set(
            a,
            "new_region_num",
            regions_info_dic[a.label_task_id].new_region_num
          );
        } else {
          this.$set(a, "less_region_num", "-");
          this.$set(a, "new_region_num", "-");
        }
      });
      return labels;
    },
    tableConfig() {
      return [
        {
          prop: "_action",
          name: "#",
          actionName: "selection_slot",
          width: "60"
        },
        {
          prop: "_action",
          name: "餐厅",
          actionName: "canteen_slot",
          width: 150
        },
        {
          prop: "_action",
          name: "机器ID",
          actionName: "machine_slot",
          width: 50
        },
        { prop: "_action", name: "来源", actionName: "source_slot", width: 50 },
        { prop: "_action", name: "批次时间", actionName: "label_date_slot" },
        { prop: "_action", name: "生成时间", actionName: "create_ts_slot" },
        {
          prop: "_action",
          name: "图框状态",
          actionName: "category_slot",
          width: 100
        },
        {
          prop: "_action",
          name: "状态",
          actionName: "status_slot",
          width: 200
        },
        {
          prop: "_action",
          name: "纠错人",
          actionName: "user_slot",
          width: 100
        },
        { prop: "_action", name: "总数", actionName: "count_slot", width: 50 },
        { prop: "_action", name: "操作", actionName: "event_slot", width: 200 }
      ];
    }
  },
  filters: {
    tsToDate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    }
  },

  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  .search-box {
    display: inline-block;
    width: 200px;
  }
  .btn-wrapper {
    padding: 0 0 5px 5px;
  }
}
</style>
